// ── Types ─────────────────────────────────────────────────────────

export interface StreamingLinks {
  soundCloud?: string;
  spotify?: string;
  appleMusic?: string;
  youtube?: string;
  instagram?: string;
  website?: string;
}

export interface ProjectData {
  id: string;
  title: string;
  status: string;
  fileCount: number;
  sourceFolder: string;
  artistId?: string;
  projectType?: string;
  priceCents?: number;
  brief?: string;
  bpm?: number;
  musicalKey?: string;
  referenceLinks?: string[];
  mainFileId?: string;
  favouriteFileId?: string;
}

export interface FileData {
  id: string;
  artistId?: string;
  projectId?: string;
  title: string;
  type: string;
  format: string;
  access: string;
  sourcePath: string;
  storageProvider?: string;
  deliveryUrl?: string;
  trackIndex?: number;
  isMainMix?: boolean;
  isFavourite?: boolean;
  createdAt?: number;
  updatedAt?: number;
}

export interface Artist {
  id: string;
  name: string;
  slug: string;
  stageName?: string;
  email?: string;
  status: string;
  membership: string;
  balanceCents: number;
  legalName?: string;
  ipiNumber?: string;
  phone?: string;
  userId?: string;
  streamingLinks?: StreamingLinks;
  source?: string;
  sourceFolder?: string;
  updatedAt?: number;
  projects: ProjectData[];
  files: FileData[];
}

export type TabId = "overview" | "files" | "packs" | "daw" | "settings" | "payments";

export interface TabDef {
  id: TabId;
  label: string;
  adminLabel?: string;
  adminOnly?: boolean;
}

export const TABS: TabDef[] = [
  { id: "overview", label: "Overview" },
  { id: "files", label: "Projects", adminLabel: "Beats" },
  { id: "packs", label: "Sounds", adminOnly: true },
  { id: "daw", label: "DAW", adminOnly: true },
  { id: "payments", label: "Payments & Emails", adminOnly: true },
  { id: "settings", label: "Settings" },
];

// ── Fallback data (used before Convex data loads) ─────────────────

export const FALLBACK_ARTISTS: Artist[] = [
  {
    id: "adrian-thomas",
    name: "Adrian Thomas",
    email: "adrianthomasmusic@gmail.com",
    status: "active",
    membership: "Studio",
    balanceCents: 0,
    slug: "adrian-thomas",
    projects: [],
    files: [],
  },
];
